module.exports = "pegasus/assets/gray-ghost-twitter-old.png";